import { Vedlegg as VedleggComponent } from "@utdanningsdirektoratet/vedlegg";
import { FormattedMessage } from "react-intl";
import { VedleggViewModel } from "../../../../ApiClients";
import { useForhåndsvisning } from "../../../../hooks";
import { FORHANDSVISNINGSKODE } from "../../../../constants/queryParam";
import { urls } from "../../../../logic/initialState";

const Vedlegg = ({
  vedlegg,
  notatVedlegg,
}: {
  vedlegg: Array<VedleggViewModel>;
  notatVedlegg: Array<VedleggViewModel>;
}) => {
  const forhåndsvisning = useForhåndsvisning();

  const searchParams = new URLSearchParams();
  if (forhåndsvisning) searchParams.set(FORHANDSVISNINGSKODE, forhåndsvisning);

  if (notatVedlegg.length === 0 && vedlegg.length === 0) return null;
  const notatVedleggList = notatVedlegg.map((v) => {
    return (
      <VedleggComponent
        key={`notatVedlegg-${v.id}`}
        className="u--marginBottom0-5"
        title={v.filNavn}
        href={`${urls.lastNedVedlegg(v.id)}?${searchParams.toString()}`}
        disabled
      />
    );
  });
  const vedleggList = vedlegg.map((v) => {
    return (
      <VedleggComponent
        key={`vedlegg-${v.id}`}
        className="u--marginBottom0-5"
        title={v.filNavn}
        href={`${urls.lastNedVedlegg(v.id)}?${searchParams.toString()}`}
        disabled
      />
    );
  });

  return (
    <div className="Page-section u--marginBottom2">
      <div className="u--label">
        <FormattedMessage id="formLabels.vedlegg" />
      </div>
      {notatVedleggList}
      {vedleggList}
    </div>
  );
};

export default Vedlegg;
